import React from 'react';
import './Header.css';

export default function () {

    return (

        <>

            <section classNameName='sec-1 '>    {/* { section 1 start with navigation} */}

                <div className="bg-dark ">

                    <nav className="navbar navbar-expand-lg ">
                        <div className="container-fluid">
                            <a className="navbar-brand text-white   text-decoration-none" href="#" ><span className='crypto-word-nav p-2 fw-bold'>Crypto</span></a>
                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                                    <li className="nav-item">
                                        <a className="nav-link active text-white p-3  text-decoration-none  " aria-current="page" href="#"><span className='text-border'>Home</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link text-white p-3  text-decoration-none" href="#"><span className='text-Hover-and-border'>About</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link text-white p-3  text-decoration-none" href="#"><span className='text-Hover-and-border'>How</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link text-white p-3  text-decoration-none" href="#"><span className='text-Hover-and-border'>Wallet</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link text-white p-3  text-decoration-none" href="#"><span className='text-Hover-and-border'>Login</span></a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link text-white p-3  text-decoration-none" href="#"><span className='text-Hover-and-border'>Sign Up</span></a>
                                    </li>


                                </ul>

                            </div>
                        </div>
                    </nav>

                </div>

            </section>   {/* { section 1 End with navigation} */}

           


        </>

    );

};

